(function () {
  'use strict';

  const SUPABASE_URL = 'https://xoolcbbpnvdylcoorlqg.supabase.co';
  const PUBLISHABLE_KEY = 'sb_publishable_bjOrV5qp2n0PtuVFOSA_6g_3Micws2T';

  function getSession() {
    try {
      const key = Object.keys(localStorage).find(
        (k) => k.includes('sb-') && k.endsWith('-auth-token')
      );

      if (!key) return null;

      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      console.error('[Corevian Admin Create] Session error:', error);
      return null;
    }
  }

  async function callRPC(functionName, payload) {
    const session = getSession();
    const accessToken = session?.access_token;

    if (!accessToken) {
      throw new Error('No active Corevian University session was found.');
    }

    const response = await fetch(
      `${SUPABASE_URL}/rest/v1/rpc/${functionName}`,
      {
        method: 'POST',
        headers: {
          apikey: PUBLISHABLE_KEY,
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
    );

    const text = await response.text();

    let body = null;

    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = text;
    }

    if (!response.ok) {
      const message =
        body?.message ||
        body?.error ||
        body?.details ||
        `Request failed with status ${response.status}`;

      throw new Error(message);
    }

    return body;
  }

  function injectStyles() {
    if (document.getElementById('cvnAdminCreateStyles')) return;

    const style = document.createElement('style');
    style.id = 'cvnAdminCreateStyles';

    style.textContent = `
      #cvnCreateDraftBtn {
        appearance: none;
        border: 1px solid #19B5B0;
        background: #19B5B0;
        color: #07101f;
        font-weight: 700;
        padding: 10px 16px;
        border-radius: 8px;
        cursor: pointer;
        margin-left: 10px;
      }

      #cvnCreateDraftBtn:hover {
        filter: brightness(1.06);
      }

      #cvnCreateDraftOverlay {
        position: fixed;
        inset: 0;
        z-index: 12000;
        background: rgba(3, 8, 18, 0.78);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
      }

      #cvnCreateDraftPanel {
        width: min(820px, 96vw);
        max-height: 92vh;
        overflow-y: auto;
        background: #0B1426;
        color: #ffffff;
        border: 1px solid rgba(25, 181, 176, 0.35);
        border-radius: 16px;
        padding: 26px;
        box-shadow: 0 24px 70px rgba(0,0,0,.45);
      }

      #cvnCreateDraftPanel h2 {
        margin: 0 0 6px;
        font-size: 25px;
      }

      #cvnCreateDraftPanel .cvn-create-subtitle {
        color: #aab6c9;
        margin-bottom: 24px;
        line-height: 1.5;
      }

      .cvn-create-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
      }

      .cvn-create-field {
        margin-bottom: 16px;
      }

      .cvn-create-field.cvn-full {
        grid-column: 1 / -1;
      }

      .cvn-create-field label {
        display: block;
        margin-bottom: 7px;
        font-size: 13px;
        font-weight: 700;
        color: #d7e0ec;
      }

      .cvn-create-field input,
      .cvn-create-field select,
      .cvn-create-field textarea {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #31415a;
        background: #111d31;
        color: #ffffff;
        border-radius: 8px;
        padding: 11px 12px;
        font: inherit;
      }

      .cvn-create-field textarea {
        min-height: 110px;
        resize: vertical;
      }

      .cvn-create-checks {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
        margin: 8px 0 22px;
      }

      .cvn-create-checks label {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #d7e0ec;
        font-size: 14px;
      }

      .cvn-create-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        border-top: 1px solid #26354c;
        padding-top: 20px;
      }

      .cvn-create-actions button {
        border-radius: 8px;
        padding: 11px 18px;
        font-weight: 700;
        cursor: pointer;
      }

      #cvnCreateCancel {
        border: 1px solid #536178;
        background: transparent;
        color: #ffffff;
      }

      #cvnCreateSubmit {
        border: 1px solid #19B5B0;
        background: #19B5B0;
        color: #07101f;
      }

      #cvnCreateMessage {
        margin: 0 0 16px;
        padding: 11px 13px;
        border-radius: 8px;
        display: none;
      }

      #cvnCreateMessage.success {
        display: block;
        background: rgba(25,181,176,.14);
        border: 1px solid rgba(25,181,176,.45);
        color: #cffffb;
      }

      #cvnCreateMessage.error {
        display: block;
        background: rgba(190,65,65,.13);
        border: 1px solid rgba(210,80,80,.45);
        color: #ffd2d2;
      }

      @media (max-width: 700px) {
        .cvn-create-grid {
          grid-template-columns: 1fr;
        }

        .cvn-create-field.cvn-full {
          grid-column: auto;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function closeCreateModal() {
    document.getElementById('cvnCreateDraftOverlay')?.remove();
  }

  function showMessage(message, type) {
    const el = document.getElementById('cvnCreateMessage');
    if (!el) return;

    el.className = type;
    el.textContent = message;
  }

  function openCreateModal() {
    if (document.getElementById('cvnCreateDraftOverlay')) return;

    const overlay = document.createElement('div');
    overlay.id = 'cvnCreateDraftOverlay';

    overlay.innerHTML = `
      <div id="cvnCreateDraftPanel">
        <h2>Create Controlled Document Draft</h2>

        <div class="cvn-create-subtitle">
          Creates a new controlled document and its initial draft version.
          The document will not become operational until it completes review and approval.
        </div>

        <div id="cvnCreateMessage"></div>

        <form id="cvnCreateDraftForm">
          <div class="cvn-create-grid">

            <div class="cvn-create-field">
              <label for="cvnDocumentCode">Document Code *</label>
              <input id="cvnDocumentCode" type="text" required placeholder="Example: CHL-SOP-013">
            </div>

            <div class="cvn-create-field">
              <label for="cvnVersionNumber">Version *</label>
              <input id="cvnVersionNumber" type="text" required value="1.0">
            </div>

            <div class="cvn-create-field cvn-full">
              <label for="cvnDocumentTitle">Document Title *</label>
              <input id="cvnDocumentTitle" type="text" required>
            </div>

            <div class="cvn-create-field">
              <label for="cvnDocumentType">Document Type *</label>
              <select id="cvnDocumentType" required>
                <option value="">Select type</option>
                <option value="policy">Policy</option>
                <option value="procedure">Procedure</option>
                <option value="sop">SOP</option>
                <option value="work_instruction">Work Instruction</option>
                <option value="training">Training Document</option>
                <option value="reference">Reference</option>
              </select>
            </div>

            <div class="cvn-create-field">
              <label for="cvnDepartment">Department *</label>
              <input id="cvnDepartment" type="text" required>
            </div>

            <div class="cvn-create-field">
              <label for="cvnDocumentOwner">Document Owner</label>
              <input id="cvnDocumentOwner" type="text">
            </div>

            <div class="cvn-create-field">
              <label for="cvnFileReference">File Reference</label>
              <input id="cvnFileReference" type="text">
            </div>

            <div class="cvn-create-field cvn-full">
              <label for="cvnDescription">Description</label>
              <textarea id="cvnDescription"></textarea>
            </div>

            <div class="cvn-create-field cvn-full">
              <label for="cvnChangeSummary">Change Summary *</label>
              <textarea
                id="cvnChangeSummary"
                required
                placeholder="For version 1.0, describe the purpose of the initial controlled release."
              ></textarea>
            </div>

            <div class="cvn-create-field cvn-full">
              <label for="cvnContentText">Document Content</label>
              <textarea
                id="cvnContentText"
                placeholder="Controlled document text may be entered here."
              ></textarea>
            </div>

          </div>

          <div class="cvn-create-checks">
            <label>
              <input id="cvnAcknowledgmentRequired" type="checkbox">
              Acknowledgment Required
            </label>

            <label>
              <input id="cvnTrainingRequired" type="checkbox">
              Training Required
            </label>

            <label>
              <input id="cvnCompetencyRequired" type="checkbox">
              Competency Required
            </label>
          </div>

          <div class="cvn-create-actions">
            <button id="cvnCreateCancel" type="button">Cancel</button>
            <button id="cvnCreateSubmit" type="submit">Create Draft</button>
          </div>
        </form>
      </div>
    `;

    document.body.appendChild(overlay);

    document
      .getElementById('cvnCreateCancel')
      .addEventListener('click', closeCreateModal);

    document
      .getElementById('cvnCreateDraftForm')
      .addEventListener('submit', async function (event) {
        event.preventDefault();

        const submitButton = document.getElementById('cvnCreateSubmit');
        submitButton.disabled = true;
        submitButton.textContent = 'Creating...';

        try {
          const payload = {
            p_document_code:
              document.getElementById('cvnDocumentCode').value.trim(),

            p_title:
              document.getElementById('cvnDocumentTitle').value.trim(),

            p_document_type:
              document.getElementById('cvnDocumentType').value,

            p_department:
              document.getElementById('cvnDepartment').value.trim(),

            p_document_owner:
              document.getElementById('cvnDocumentOwner').value.trim() || null,

            p_description:
              document.getElementById('cvnDescription').value.trim() || null,

            p_version_number:
              document.getElementById('cvnVersionNumber').value.trim(),

            p_change_summary:
              document.getElementById('cvnChangeSummary').value.trim(),

            p_content_text:
              document.getElementById('cvnContentText').value.trim() || null,

            p_file_reference:
              document.getElementById('cvnFileReference').value.trim() || null,

            p_acknowledgment_required:
              document.getElementById('cvnAcknowledgmentRequired').checked,

            p_training_required:
              document.getElementById('cvnTrainingRequired').checked,

            p_competency_required:
              document.getElementById('cvnCompetencyRequired').checked
          };

          const result = await callRPC(
            'create_controlled_document_draft',
            payload
          );

          console.log('[Corevian Admin Create] Draft created:', result);

          showMessage(
            'Draft created successfully. It is not yet approved or operational.',
            'success'
          );

          document.getElementById('cvnCreateDraftForm').reset();
          document.getElementById('cvnVersionNumber').value = '1.0';

          const adminOverlay =
            document.getElementById('cvnAdminDocsOverlay');

          if (adminOverlay) {
            const refreshButton = Array.from(
              adminOverlay.querySelectorAll('button')
            ).find(
              (button) =>
                button.textContent.trim() === 'Refresh Register'
            );

            if (refreshButton) {
              setTimeout(() => refreshButton.click(), 400);
            }
          }

        } catch (error) {
          console.error('[Corevian Admin Create] Create failed:', error);
          showMessage(error.message || 'Unable to create draft.', 'error');
        } finally {
          submitButton.disabled = false;
          submitButton.textContent = 'Create Draft';
        }
      });
  }

  function installButton() {
    const adminOverlay = document.getElementById('cvnAdminDocsOverlay');

    if (!adminOverlay) return false;

    if (document.getElementById('cvnCreateDraftBtn')) return true;

    const refreshButton = Array.from(
      adminOverlay.querySelectorAll('button')
    ).find(
      (button) =>
        button.textContent.trim() === 'Refresh Register'
    );

    if (!refreshButton) return false;

    const createButton = document.createElement('button');
    createButton.id = 'cvnCreateDraftBtn';
    createButton.type = 'button';
    createButton.textContent = 'Create Draft';

    refreshButton.insertAdjacentElement('beforebegin', createButton);

    createButton.addEventListener('click', openCreateModal);

    return true;
  }

  function watchForAdminCommandCenter() {
    injectStyles();

    installButton();

    const observer = new MutationObserver(function () {
      installButton();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      watchForAdminCommandCenter
    );
  } else {
    watchForAdminCommandCenter();
  }
})();